// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Ref } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import { BootstrapImage } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { ImageRatio } from '../_contracts';
import { prepareImage } from '../_filters';
import { stickyBarConfig } from './StickyBar.config';
let StickyBarModuleUi = class StickyBarModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.image = null;
        this.isFixed = false;
        this.link = '';
        this.stickyBarConfig = stickyBarConfig;
        this.onResize = debounce(this.getBarHeight, 100);
    }
    get hasContent() {
        return !!this.module.content.label || !!this.image;
    }
    get themeClass() {
        return this.stickyBarConfig[this.module.content.color];
    }
    async fetchRelated() {
        try {
            await Promise.allSettled([
                this.fetchImage(),
                this.fetchLink()
            ]);
            this.onReady();
        }
        catch (e) {
            this.onError(e);
        }
    }
    getBarHeight() {
        if (!this.bar || !this.wrapper) {
            return;
        }
        const stickyBarHeight = this.bar.getBoundingClientRect().height + 'px';
        this.wrapper.style.height = stickyBarHeight;
        document.documentElement.style.setProperty('--sticky-bar-height', stickyBarHeight);
    }
    watchResize() {
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('resize', this.onResize);
    }
    unwatchResize() {
        if (typeof window === 'undefined') {
            return;
        }
        window.removeEventListener('resize', this.onResize);
    }
    onLoaded() {
        setTimeout(() => this.getBarHeight(), 0);
    }
    watchScroll() {
        if (!this.wrapper) {
            return;
        }
        this.getBarHeight();
        const offset = document.documentElement.style.getPropertyValue('--navbar-height');
        const observer = new IntersectionObserver((entries) => {
            this.isFixed = !entries[0].isIntersecting;
        }, {
            root: null,
            rootMargin: `${offset ? '-' + offset : '0px'} 0px`,
            threshold: [0.99, 1]
        });
        observer.observe(this.wrapper);
    }
    async fetchImage() {
        let imageFile;
        if (typeof this.module.content.image === 'object' &&
            this.module.content.image !== null &&
            Number.isInteger(this.module.content.image.value)) {
            imageFile = await this.relatedService.resolve(this.module.content.image, {});
            this.image = prepareImage(imageFile, ImageRatio.Original, undefined, true);
        }
    }
    async fetchLink() {
        let content;
        if (this.module.content.readMoreUrl && typeof this.module.content.readMoreUrl === 'string') {
            this.link = this.module.content.readMoreUrl;
        }
        else if (this.module.content.readMoreLink) {
            if (typeof this.module.content.readMoreLink === 'object' &&
                Number.isInteger(this.module.content.readMoreLink.value)) {
                content = await this.relatedService.resolve(this.module.content.readMoreLink, {});
                this.link = content.urlPath;
            }
        }
    }
};
__decorate([
    Ref('wrapper')
], StickyBarModuleUi.prototype, "wrapper", void 0);
__decorate([
    Ref('bar')
], StickyBarModuleUi.prototype, "bar", void 0);
StickyBarModuleUi = __decorate([
    Component({
        name: 'StickyBarModuleUi',
        components: {
            BootstrapImage
        },
        async created() {
            await this.fetchRelated();
        },
        mounted() {
            this.watchScroll();
            this.watchResize();
        },
        beforeDestroy() {
            this.unwatchResize();
        },
        template: `
    <section ref="wrapper"
             class="sticky-bar-module module" :class="[debugClass, loadingClass]">
    <div ref="bar" class="sticky-bar__wrap" :class="{'fixed': isFixed}">
      <div class="container" v-if="hasContent || debug">
        <a :href="link" class="sticky-bar" :class="themeClass">
          <BootstrapImage v-if="image" v-bind="{ ...image, isLazy: true }" class="sticky-bar__image" @load="onLoaded"/>
          <div class="sticky-bar__content">{{ module.content.label }}</div>
        </a>
      </div>
    </div>
    </section>
  `
    })
], StickyBarModuleUi);
export { StickyBarModuleUi };
